// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Anloc","ribbon":"_1YBtwR","offset-8":"_3KHc9F","offset-16":"qXyH1V","shine-lines":"UCq70I"};